import React from 'react';
import Link from 'next/link';
import * as rdd from 'react-device-detect';
import { func } from '../helpers';


const Header = (props) => {

    const { _data: { navigation } } = props;

    const [root, setRoot] = React.useState('');
    const [mounted, setMounted] = React.useState(false);
    const [isMobile, setIsMobile] = React.useState(false);

    React.useEffect(() => {
        setMounted(true);
        setIsMobile(rdd.isMobile);
        setRoot(window.location.pathname.replace('/', ''));

        func.fingerprint();
    }, []);

    return (
        <React.Fragment>
            {mounted && (
                <>
                    <header className="main-header header-style-1 font-heading">
                        <div className="header-top">
                            <div className="container">
                                <div className="row pt-10 pb-5">
                                    <div className="col-md-3 col-xs-6">
                                        <a href="./">
                                            <img className="logo" src={`assets/img/logo.png?v=${func.app.version}`} alt="" style={{ height: 35 }} />
                                        </a>
                                    </div>
                                    <div className="col-md-9 col-xs-6 text-right header-top-right ">
                                        <ul className="list-inline nav-topbar d-none d-md-inline">

                                            {navigation.map(nav => (
                                                <li key={nav.name} className="list-inline-item">
                                                    <Link href={`/${nav.link}`}>
                                                        <a className={nav.link === root ? 'text-primary' : ''}>
                                                            {func.intl(`Nav.${nav.link || 'home'}`, nav.name)}
                                                        </a>
                                                    </Link>
                                                </li>
                                            ))}

                                        </ul>
                                        {/* <a href="./" className="btn btn-radius bg-primary text-white ml-15 font-small box-shadow">Create an award</a> */}

                                        {isMobile && (
                                            <div className="off-canvas-toggle-cover d-inline-block ml-4 mr-2">
                                                <div className="off-canvas-toggle hidden d-inline-block" id="off-canvas-toggle">
                                                    <span></span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>

                    <aside id="sidebar-wrapper" className="custom-scrollbar offcanvas-sidebar">
                        <button className="off-canvas-close"><i className="elegant-icon icon_close"></i></button>
                        <div className="sidebar-inner">
                            <div className="sidebar-widget widget_categories mb-50 mt-30">
                                <div className="widget-header-2 position-relative">
                                    <h5 className="mt-5 mb-15">Menu</h5>
                                </div>
                                <div className="widget_nav_menu">
                                    <ul>
                                        {navigation.map(nav => (
                                            <li key={nav.name} className="cat-item cat-item-2">
                                                <Link href={`/${nav.link}`}>
                                                    <a className={nav.link === root ? 'text-primary' : ''}>
                                                        {func.intl(`Nav.${nav.link || 'home'}`, nav.name)}
                                                    </a>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </aside>
                </>
            )}
        </React.Fragment>
    );
}


export default Header;